<template>
    <svg class="icon" :class="'icon-' + name" @click="clicked">
        <use :xlink:href="xlink"/>
    </svg>
</template>

<script>

export default {
    props: ['name'],
    data () {
        return {
            icon: this.name
        }
    },
    computed: {
        xlink () {
            return require('./assets/svg/' + this.icon + '.svg').default
        }
    },
    methods: {
        clicked () {
            this.$emit('click')
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/icon.vue